interface GeoPromptProps {
  isLocating: boolean;
  onEnable: () => void;
  onDismiss: () => void;
}

/**
 * Inline banner asking for geolocation permission so results can be sorted by
 * distance. Extracted verbatim from SearchPage.
 */
export const GeoPrompt = ({ isLocating, onEnable, onDismiss }: GeoPromptProps) => (
  <div className="flex items-center gap-3 p-3 bg-primary-50 border border-primary-200 rounded-lg">
    <svg className="w-5 h-5 text-primary-700 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
    <p className="text-sm text-primary-900 flex-1">
      Enable location access to sort wineries by distance and see how far each one is from you.
    </p>
    <button
      type="button"
      onClick={onEnable}
      disabled={isLocating}
      className="px-3 py-1.5 text-sm font-medium text-white bg-primary-700 rounded-md hover:bg-primary-800 disabled:opacity-50 flex-shrink-0"
    >
      {isLocating ? 'Locating...' : 'Enable'}
    </button>
    <button
      type="button"
      onClick={onDismiss}
      className="text-primary-400 hover:text-primary-700 flex-shrink-0"
      aria-label="Dismiss"
    >
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
);
